export const theme = {
  link: '#ffffff',
  icon: '#ffffff',
  focus: '#ffffff',
  hoverBackground: '#EEF6F7',
  body: {
    background: '#F6F6F6',
    text: '#333333',
  },
  accordion: {
    headerBackgroundColor: '#ffffff',
    activeHeaderBackgroundColor: '#ffffff',
    activeHeaderBorderBottomLeftRadius: '0px #ffffff',
    activeHeaderBorderBottomRightRadius: '0px #ffffff',
    activeHeaderBorderColor: '#ffffff',
    border: '0px #ffffff',
  },
  tooltip: {
    borderColor: '#ffffff',
    backgroundColor: '#ffffff',
    color: '#000000',
  },
  button: {
    primary: {
      text: '#FFFFFF',
      hover: '#2A5166',
    },
    secondary: {
      hover: '#EBF0F2',
    },
    text: '#ffffff',
    background: '#2A5166',
  },
  binart: {
    background: '#ffffff',
    disableBackground: '#ebf0f2',
    disableBorderColor: '#9eb5c2',
  },
  field: {
    icon: '#ffffff',
    focus: '#ffffff',
    label: '#ffffff',
  },
  checkbox: {
    background: '#ffffff',
    font: '#FFFFFF',
  },
  chip: {
    hover: '#ffe5ad',
    text: '#ffffff',
  },
  switch: {
    background: '#ffffff',
  },
  radio: {
    border: '#ffffff',
    background: '#ffffff',
    inactiveBorder: '#656565',
    focusBackground: '#CECFD1',
  },
  navigation: {
    activeTabText: '#ffffff',
    activeTabBorder: '#ffffff',
  },
  datepicker: {
    navIcon: '#515151',
    shadow: 'rgba(0, 0, 0, 0.12)',
    disabled: '#e9e9e9',
    legend: {
      selectedDate: {
        fill: '#ffffff',
        border: '#ffffff',
        text: '#ffffff',
      },
      dueDate: {
        fill: 'transparent',
        border: '#ffffff',
        text: '#333333',
      },
      lateFeeDate: {
        fill: '#757575',
        border: '#757575',
        text: '#ffffff',
      },
    },
  },
  footer: {
    background: '#ffffff',
  },
  header: {
    background: '#F6F6F6',
    text: '',
    border: '',
  },
  progressStepBar: {
    fill: '#ffffff',
    hover: '#D6E0E5',
    label: '#ffffff',
  },
  progressBar: {
    complete: '#2A5166',
    error: '#c63527',
    inProgress: '#2A5166',
    background: '#e9eaeb',
  },
};
